import { deleteSubscriberApi, getSubscribersApi } from "api/subscribers";
import {
  takeEvery,
  fork,
  put,
  all,
  call,
  takeLatest,
} from "redux-saga/effects";
import {
  deleteSubscriberFailure,
  deleteSubscriberSuccess,
  getSubscribersFailure,
  getSubscribersSuccess,
} from "./actions";
import { DELETE_SUBSCRIBER, GET_SUBSCRIBERS } from "./actionTypes";

function* getSubscribersSaga({ payload }) {
  try {
    const { data } = yield call(getSubscribersApi, payload);
    yield put(getSubscribersSuccess(data));
  } catch (error) {
    console.log(error);
    yield put(getSubscribersFailure(error));
  }
}

// ===================================================
// ===================================================

function* deleteSubscriberSaga({ payload }) {
  try {
    yield call(deleteSubscriberApi, payload);
    yield put(deleteSubscriberSuccess(payload));
  } catch (error) {
    console.log(error);
    yield put(deleteSubscriberFailure(error));
  }
}

// ===================================================
// ===================================================

export function* watchGetSubscribers() {
  yield takeEvery(GET_SUBSCRIBERS, getSubscribersSaga);
}

export function* watchDeleteSubscriber() {
  yield takeLatest(DELETE_SUBSCRIBER, deleteSubscriberSaga);
}

// ===================================================
// ===================================================

function* subscribersSaga() {
  yield all([fork(watchGetSubscribers)]);
  yield all([fork(watchDeleteSubscriber)]);
}

export default subscribersSaga;
